import { v4 as uuidv4 } from 'uuid';
import ExportDocumentToolsGridPluginSettings from './ExportDocumentToolsGridPluginSettings';
import ExportDocumentToolsGrid from './ExportDocumentToolsGrid';

export const ExportDocumentToolsTab = (): ITab => {
    return {
        id: uuidv4(),
        title: 'Настройка экспорта документов',
        view: {
            content:    ExportDocumentToolsGridPluginSettings 
                        ? <ExportDocumentToolsGrid gridId={uuidv4()} plugin={ExportDocumentToolsGridPluginSettings}/>
                        : <p> Справочник не настроен </p>
        }
    }
}

export default ExportDocumentToolsTab